import { all, fork } from 'redux-saga/effects';

import { landgingPageWatcherSaga } from './sagaLandingpage';
import { authSaga } from './auth';
import { HeaderWatcherSaga } from './sagaHeader';

import { usersSaga } from './userSaga';
import { expenseSaga } from './sagaExpense';
import { bankSaga } from './sagaBanks';
import { expenseDetailSaga } from './sagaExpenseDetails';
import { FilterSaga } from './filterSearchSaga';
import { KYCSaga } from './kycSaga';
import { BalanceSaga } from './billSaga';
import { EmandateSaga } from './emandateSaga';
import { EMandateModifySaga } from './eMandateModifySaga';
import { vendorSaga } from './sagaVendor';
import { invoiceSaga } from './sagaInvoice';
import { bulkVendorSaga } from './sagaBulkVendor';

export default function* rootSaga() {
  yield all([
    // add other watchers to the array
    fork(authSaga),
    fork(landgingPageWatcherSaga),
    fork(HeaderWatcherSaga),
    fork(usersSaga),
    fork(expenseSaga),
    fork(bankSaga),
    fork(expenseDetailSaga),
    fork(FilterSaga),
    fork(KYCSaga),
    fork(BalanceSaga),
    fork(EmandateSaga),
    fork(EMandateModifySaga),
    fork(vendorSaga),
    fork(invoiceSaga),
    fork(bulkVendorSaga),
  ]);
}
